import { styled } from '@mui/material';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(8),
  borderTop: `1px solid ${theme.palette.primary.light}`
}));

export default AccordionDetails;
